import React, { useState } from 'react';
import PropTypes from 'prop-types';

const TextAreaInput = ({
  type,
  rows = 1,
  inputValue = '',
  handleChange,
  label,
  errorMsg = null,
  className,
  onFocus,
  onBlur,
  onKeyUp,
  maxLength,
  minLength,
  disabled = false,
  required = false,
  regex = null,
  value = '',
  isStarRequired = false,
  autoFocus = false,
  fwidth=false
}) => {
  const [isError, setIsError] = useState(false);
  const [isValue, setIsValue] = useState(value.length ? value : '');

  const handleNameBlur = (val) => {
    if (regex !== null) {
      if (regex) {
        setIsError(false);
        setIsValue(val);
      } else {
        setIsError(true);
      }
    }
  };
  return (
    <div className={(fwidth) ? `form-group custom-fwidth` : `form-group full-width`}>
      <textarea
        type={type}
        rows={rows}
        className={`form-control ${className}`}
        onKeyPress={() => handleNameBlur(isValue)}
        value={inputValue}
        onChange={handleChange}
        onFocus={onFocus}
        onBlur={onBlur}
        onKeyUp={onKeyUp}
        maxLength={maxLength}
        minLength={minLength}
        disabled={disabled ? 'disabled' : ''}
        required={required ? 'required' : ''}
        autoFocus={autoFocus}
      />
      <label className="placeholder">
        {label}
        {isStarRequired && (
          <span className="label-star" style={{ color: 'red' }}>
            {' '}
            *{' '}
          </span>
        )}
      </label>
      <label className={`error ${isError ? 'd-block' : ''}`}>{errorMsg}</label>
    </div>
  );
};

TextAreaInput.propTypes = {};

export default TextAreaInput;
